import React from 'react';
import './Sub-services.css';
import panelSucio from './assets/panel sucio.jpeg'; // Asegúrate de que la ruta sea correcta
import limPanel from './assets/limpieza de panel.jpeg';
import lavaPanel from './assets/lim panel.jpeg';

const MantenimientoFotovoltaicoContent = () => {
  return (
    <div className="containerSer">
      <h2>Mantenimiento de Sistemas Fotovoltaicos</h2>
      <div className="subservice-gallery">
        <img
          // Added objectFit
          src={panelSucio}
          alt="Imagen de los paneles antes del mantenimiento"
          className="panel-sucio-image"
        />
        <img
          // Added objectFit
          src={limPanel}
          alt="Imagen de los paneles durante la limpieza"
          className="panel-sucio-image"
        />
        <img
           // Added objectFit
          src={lavaPanel}
          alt="Imagen de los paneles después de la limpieza"
          className="panel-sucio-image"
        />
      </div>
      <p>
        El mantenimiento de los sistemas fotovoltaicos consiste en la limpieza,
        cambio de piezas desgastadas, ajuste de estructuras, reacomodación o
        ajuste de piezas y demás acciones que garantizan el adecuado
        funcionamiento del sistema, ayudando a evitar fallas, pérdidas de
        energía y aumentar la vida útil; además de evitar inconvenientes en
        infraestructura que puedan afectar a los residentes.
      </p>
      <p>
        Este servicio te incluye: revisión visual, limpieza de paneles; revisión
        de conexiones eléctricas, inversores y fusibles; pruebas de
        funcionamiento, ajuste de protecciones; reemplazo preventivo de
        componentes críticos (baterías, conectores); informe claro con
        hallazgos, recomendaciones, soporte técnico y atención rápida ante
        cualquier eventualidad.
      </p>

      <h3>Beneficios clave:</h3>
      <ul>
        <li>Máximo rendimiento.</li>
        <li>
          Ahorro real, evitando gastos grandes por reparaciones inesperadas y
          mantienes tu factura baja.
        </li>
        <li>Mayor vida útil.</li>
        <li>Seguridad garantizada.</li>
        <li>Tranquilidad al dejar este proceso en manos de expertos.</li>
      </ul>
    </div>
  );
};

export default MantenimientoFotovoltaicoContent;
